module.exports = __webpack_public_path__ + "279d808bda4caf060e854c9e1e13c597.svg";